import { useState, useEffect } from "react";
import { Modal, Button, Form, Input, Spin } from "antd";
import { withRouter } from "react-router";
import { getBlogTagById, updateBlogTagById } from "@api/blog/blog";
import { SuccessNotification, ErrorNotification } from "../../..";

const initialState = {
  name: "",
};

const BlogTagUpdateModal = ({
  open,
  handleModalClick,
  fetchBlogTags,
  tagId,
}) => {
  const [values, setValues] = useState(initialState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch blogTag by id
    handleFetchBlogTagById();
  }, []);

  // Handle fetch blogTag by id
  const handleFetchBlogTagById = async () => {
    setLoading(true);
    try {
      const { data } = await getBlogTagById(tagId);

      setValues(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("GET_TAG_BY_ID_ERROR", err);
    }
  };

  // Handle form change
  const handleFormChange = (e) => {
    e.preventDefault();
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  // Handle blogTag update
  const handleBlogTagUpdate = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Validate form
    if (!values.name) {
      setLoading(false);
      return ErrorNotification("Please enter a name");
    }

    // Update blogTag
    updateBlogTagById(tagId, values)
      .then(() => {
        setValues(initialState);
        handleModalClick();
        fetchBlogTags();
        SuccessNotification("BlogTag updated successfully");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        ErrorNotification(err.response.data.message);
      });
  };

  return (
    <>
      <Modal
        title="Update BlogTag"
        visible={open}
        onOk={handleModalClick}
        closable={false}
        footer={[
          <Button key="back" onClick={handleModalClick}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleBlogTagUpdate}
            loading={loading}
          >
            Update
          </Button>,
        ]}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(80vh - 50px)",
            }}
          >
            <Spin />
          </div>
        ) : (
          <Form
            labelCol={{
              span: 5,
            }}
            wrapperCol={{
              span: 16,
            }}
          >
            {/* BlogTag name */}
            <Form.Item label="Name">
              <Input
                name="name"
                placeholder="Enter blogTag name"
                onChange={handleFormChange}
                value={values.name}
                rules={[{ required: true }]}
              />
            </Form.Item>
          </Form>
        )}
      </Modal>
    </>
  );
};

export default withRouter(BlogTagUpdateModal);
